export default {

    methods: {
        getComponentName(tabName) {
            if (tabName === 'Personal') {
                return `Employee${tabName.replace(/\s+/g, '')}`;
            } else if (tabName === 'Stages/Progress') {
                return 'Status';
            } else {
                return `${tabName.replace(/\s+/g, '')}`;
            }
        },

        setActiveTab(tabName) {
            this.activeTabIndex = this.tabs.indexOf(tabName);
            window.history.pushState({ tab: tabName }, "", `?tab=${tabName}`);
        },

        getActiveTab() {

            const urlParams = new URLSearchParams(window.location.search);
            const tab = urlParams.get('tab');

            if (null === tab) {
                return;
            }

            for (let i = 0; i < this.tabs.length; i++) {
                if (this.tabs[i] === tab) {
                    this.activeTabIndex = i;
                }
            }
        },
    }
}
